export default {
  skins: {
    'animals': [
      'img/skins/animals/cat.svg',
      'img/skins/animals/dog.svg',
      'img/skins/animals/pig.svg',
      'img/skins/animals/rabbit.svg'
    ],
    'cards_suits': [
      'img/skins/suits/hearts.svg',
      'img/skins/suits/crosses.svg',
      'img/skins/suits/spades.svg',
      'img/skins/suits/tambourines.svg'
    ],
    'fruits': [
      'img/skins/fruits/apple.svg',
      'img/skins/fruits/pear.svg',
      'img/skins/fruits/cherries.svg',
      'img/skins/fruits/grapes.svg'
    ],
    'vegetables': [
      'img/skins/vegetables/carrot.svg',
      'img/skins/vegetables/pumpkin.svg',
      'img/skins/vegetables/eggplant.svg',
      'img/skins/vegetables/broccoli.svg'
    ]
  }
}